import React from "react";
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import MyLibrary from "../components/MyLibrary";

const ProfilePage = () => (
  <Layout pageTitle="HiTech | Thư viện của Tôi">
    <Topbar />
    <NavOne />
    <MyLibrary />
    <Footer />
  </Layout>
);

export default ProfilePage;
